import styles from './SkillPill.module.css'

/**
 * SkillPill — displays a skill classification pill with a color variant.
 *
 * Props:
 *   label    {string}  — the skill class label (e.g. "Infrastructure")
 *   variant  {string}  — color variant: 'infrastructure' | 'backend' | 'security'
 *                        | 'process' | 'core' | 'technical' | 'general'
 *                        Defaults to 'general' if not provided or unrecognized.
 */
export default function SkillPill({ label, variant }) {
  const variantClass = styles[variant] ?? styles.general

  return (
    <span className={`${styles.pill} ${variantClass}`}>
      {label}
    </span>
  )
}
